enum TipoItem {
  PACOTE = 'PACOTE',
  PRODUTO = 'PRODUTO',
}

export default TipoItem;
